/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Account { 
    productId?: number;
    productName?: string | null;
    accountNumber?: string | null;
    minAmount?: string | null;
    maxAmount?: string | null;
    tenureMin?: number;
    tenureMax?: number;
    tenurePeriodType?: string | null;
}

